<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm">
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-3 mark">
          <h1 v-html="data.error.errorHeader"></h1>
          <div class="clearfix"></div>
          <p v-html="data.error.errorContentText"></p>
          <div v-if="err">
            <label v-html="data.error.errorMsgLabel"></label>
            <pre class="pre">{{ err }}</pre>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-link--ext btn-lg btn-block"
            @click="$router.push('/')" v-html="data.error.toStartBtn"></button>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'

export default {
  name: 'errorcontent',
  props: ['error'],
  data () {
    return {
      data: null,
      err: this.$props.error ? this.$props.error : '',
      language: sessionStorage.getItem('language')
    }
  },
  components: {},
  methods: {},
  async mounted () {
    this.data = await request({
      query: `
        {
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorHeader
            errorContentText
            errorMsgLabel
            goBackBtn
            toStartBtn
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding-bottom: 6vh;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
.pre {
  padding: 10px;
  border: 1px solid gray;
  border-radius: 5px;
}
.btn-link--ext {
  color: #1a61d3bb;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 4vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorContent.vue